import React from 'react'

const Terminal = (props) => {
  React.useEffect(() => {
    let cursorBlink = setInterval(() => {
      let cursor = document.getElementById("cursor")
      cursor.style.visibility = cursor.style.visibility === "visible" ? "hidden" : "visible"
    }, 500)

    return (() => {
      clearInterval(cursorBlink)
    })
  }, [])

  return (
    <div
      id="terminal_window"
      className="window"
      style={{
        position: "absolute",
        height: "90%",
        width: "90%",
        left: "5%",
        top: "5%",
      }}
    >
      <div
        id="terminal"
        style={{
          position: "relative",
          backgroundImage: "linear-gradient(0deg, rgba(0, 0, 0, 0.9), rgba(0, 150, 0, 0.5) 120%)",
          height: "100%",
          width: "100%",
          overflow: "auto",
          padding: "6vw",
          textAlign: "left",
          userSelect: "none",
          msUserSelect: "none",
          WebkitTouchCallout: "none",
          WebkitUserSelect: "none"
        }}
      >
        <div
          style={{
            width: "100%",
            color: "white",
            padding: "2vw 6vw",
            font: "3vw Inconsolata, monospace",
            textShadow: "0 0 5px #C8C8C8",
          }}
          dangerouslySetInnerHTML={{
            __html: props.code + props.input + " <span id='cursor'>&#9642;</span>"}}
        />
        <div
          style={{
            position: "absolute",
            color: "white",
            font: "3vw Inconsolata, monospace",
            top: "8vw"
          }}
        >
          ~$ &nbsp;
        </div>
      </div>
      <div
        id="terminal_overlay"
        style={{
          position: "absolute",
          zIndex: 2,
          top: 0,
          background: "repeating-linear-gradient(0deg, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15) 1px, transparent 1px, transparent 2px)",
          height: "100%",
          width: "100%"
        }}
      />
    </div>
  )
}

export default Terminal
